// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appbar-container {\n  height: 50px;\n  width: 100%;\n  background-color: #ed8079;\n  background-color: var(--color-primary);\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.appbar-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.appbar-chat-button {\n  margin-right: 8px;\n  height: 30px;\n}\n\n.appbar-sign-out-button {\n  margin-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
